var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_8570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4012 23.5149C33.6796 22.8918 31.7685 23.0357 30.1574 23.9098C30.1364 23.9202 23.8496 26.7614 23.8496 26.7614C23.403 27.096 22.885 27.2727 22.3515 27.2727H18.396C17.9047 27.2727 17.5063 26.8748 17.5063 26.3841C17.5063 25.8933 17.9047 25.4954 18.396 25.4954H22.3515C23.588 25.4954 23.615 22.9516 22.404 22.8508L16.8909 22.7874C15.918 22.7767 14.9444 22.1514 13.9189 22.1279C12.8752 22.104 11.8878 22.3702 11.0103 22.9393C9.78847 23.7318 8.95431 24.9912 8.3952 26.3117L11.378 33.8441H19.9546C20.7299 33.8438 21.4918 33.6412 22.1649 33.2566L35.4751 25.6423C35.8798 25.2991 36.1924 24.8984 36.0551 24.2831C35.9777 23.9371 35.7295 23.6339 35.4012 23.5149ZM2.875 27.2347L6.93994 37.5L10.2028 35.7084L6.13778 25.4432L2.875 27.2347ZM27.3701 2.5C23.0058 2.5 19.468 6.08578 19.468 10.509C19.468 14.9323 23.0059 18.518 27.3701 18.518C31.7342 18.518 35.2721 14.9323 35.2721 10.509C35.2722 6.08578 31.7343 2.5 27.3701 2.5Z",
    fill: "#F8821B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0353 10.4227H30.5721V11.1684L28.6314 11.191L28.3285 11.7785V12.2192H30.5721V12.9761H28.3285V14.75H27.3077V12.9761H25.0641V12.2192H27.3077V11.7785L26.9936 11.191L25.0641 11.1684V10.4227H26.601L24.75 6.875H25.8942L27.8125 10.852L29.7308 6.875H30.875L29.0353 10.4227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_8570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayImg);
export default __webpack_public_path__ + "static/media/pay-img.5c8f6f6cedd6ea4502b18d943fff871b.svg";
export { ForwardRef as ReactComponent };